import styled from "styled-components";

export const Container = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 50dvh;

    h3 {
        font-size: .9rem;
        font-weight: 600;
    }
`